import { AltiusRes } from "store/types";
import { AsyncActions, AsyncActionsParams } from "../base";

interface IRootDealActions {}

export class RootDealActions extends AsyncActions implements IRootDealActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }

  // A deal's ownership (own vs shared-from-another-account) is stable, but getDealAction checks it before
  // every fetch — so cache the answer per deal id to avoid a repeated GET /another-account-deal/{id}.
  // Caching the promise also dedupes concurrent checks; it resets when the actions instance is rebuilt.
  private sharedDealCache = new Map<number, Promise<boolean>>();

  protected isSharedDeal = (id: number): Promise<boolean> => {
    const cached = this.sharedDealCache.get(id);
    if (cached) return cached;

    const request = this.api
      .get<AltiusRes<{ is_deal_from_another_account: boolean }>>({
        url: `/api/v0.0.3/another-account-deal/${id}`
      })
      .then(({ data: { data } }) => data.is_deal_from_another_account)
      .catch((error) => {
        // Don't cache failures — allow a retry on the next fetch.
        this.sharedDealCache.delete(id);
        throw error;
      });

    this.sharedDealCache.set(id, request);
    return request;
  };
}
